import { extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { formatClassName as _formatClassName } from '../../../utils/formatClassName.js';
import { LegacyDragHandle } from './legacy-drag-handle.js';
import { CardSpecialLabel } from '../../CardComponents/card-special-label/component.js';
import { LegacyDismissAction } from './legacy-dismiss-action.js';
import { LegacyMediaBox } from './legacy-media-box.js';
import { LegacyTextBox } from './legacy-text-box.js';
import { LegacyParentBox } from './legacy-parent-box.js';
import { LegacyCardActions } from './legacy-card-actions.js';
import { LegacyCardChildren } from './legacy-card-children.js';
var LegacyNarrowHorizontalContainer = function LegacyNarrowHorizontalContainer(_ref) {
  var cardProps = _ref.cardProps,
    cardEffects = _ref.cardEffects;
  var containerClass = cardProps.containerClass,
    isSortable = cardProps.isSortable,
    specialLabel = cardProps.specialLabel,
    dismissable = cardProps.dismissable,
    onDismiss = cardProps.onDismiss,
    mediaUrl = cardProps.mediaUrl,
    mediaContent = cardProps.mediaContent;
  var mediaRight = cardEffects.mediaRight,
    hasMedia = cardEffects.hasMedia,
    cardType = cardEffects.cardType;
  var cardMainContainerClasses = _formatClassName([containerClass, 'card-main-container', {
    'media-right': mediaRight
  }]);
  var contentClasses = _formatClassName(['d-flex', {
    'flex-row-reverse w-100': mediaRight
  }]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: cardMainContainerClasses
  }, /*#__PURE__*/React.createElement(LegacyDragHandle, {
    isSortable: isSortable
  }), specialLabel && /*#__PURE__*/React.createElement(CardSpecialLabel, _extends({}, specialLabel, {
    type: cardType,
    hasMedia: hasMedia,
    chakra: 'off'
  })), /*#__PURE__*/React.createElement("div", {
    className: "presentation-card-content narrow-horizontal"
  }, /*#__PURE__*/React.createElement(LegacyDismissAction, {
    dismissable: dismissable,
    onDismiss: onDismiss
  }), /*#__PURE__*/React.createElement("div", {
    className: contentClasses
  }, (mediaUrl || mediaContent) && /*#__PURE__*/React.createElement(LegacyMediaBox, {
    cardProps: cardProps,
    cardEffects: cardEffects
  }), /*#__PURE__*/React.createElement(LegacyTextBox, {
    extraProps: {
      className: mediaRight ? 'me-auto' : 'ms-3'
    },
    cardProps: cardProps,
    cardEffects: cardEffects
  })), /*#__PURE__*/React.createElement("div", {
    className: "card-action-content"
  }, /*#__PURE__*/React.createElement(LegacyParentBox, {
    cardProps: cardProps,
    cardEffects: cardEffects
  }), /*#__PURE__*/React.createElement(LegacyCardActions, {
    cardProps: cardProps,
    cardEffects: cardEffects
  })))), /*#__PURE__*/React.createElement(LegacyCardChildren, {
    cardEffects: cardEffects,
    cardProps: cardProps
  }));
};
export { LegacyNarrowHorizontalContainer };